import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'

import { NotFoundView } from '#admin/components/not-found-view.tsx'
import { TenantActions } from '#admin/features/platform/tenants/tenant-actions.tsx'
import { TenantHeader } from '#admin/features/platform/tenants/tenant-header.tsx'
import { tenantQuery } from '#admin/features/platform/tenants/queries.ts'
import { TenantSkeleton } from '#admin/features/platform/platform-skeletons.tsx'

/** `/platform/tenants/$tenantId/*` — one edition. The header and tabs are shared by every tab. */
export const Route = createFileRoute('/_authenticated/platform/tenants/$tenantId')({
  pendingComponent: TenantSkeleton,
  staticData: { crumb: useTenantCrumb },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(tenantQuery(params.tenantId)),
  notFoundComponent: NotFoundView,
  component: TenantLayout,
})

function useTenantCrumb(): string {
  const { tenantId } = Route.useParams()
  return useQuery(tenantQuery(tenantId)).data?.name ?? 'Edition'
}

function TenantLayout() {
  const { tenantId } = Route.useParams()
  const { data: tenant } = useSuspenseQuery(tenantQuery(tenantId))

  return (
    <>
      <TenantHeader tenant={tenant} actions={<TenantActions tenant={tenant} />} />
      <Outlet />
    </>
  )
}
